export const DIALECT_BLOCKCHAIN_SDK_TYPE_SOLANA = 'solana';
//# sourceMappingURL=constants.js.map